import React from 'react';

export default function SquaresIcon() {
  return (
  	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.75" y="0.5" width="7" height="7" rx="2" fill="#111418"/>
      <rect x="8.75" y="0.5" width="7" height="7" rx="2" fill="#111418"/>
      <rect x="8.75" y="8.5" width="7" height="7" rx="2" fill="#111418"/>
      <rect x="0.75" y="8.5" width="7" height="7" rx="2" fill="#111418"/>
    </svg>
  );
}
